import { compose } from "ramda";
import { memo, MouseEvent, useState } from "react";

import { Checkbox, CheckboxProps } from "../Checkbox";
import { Dialog } from "../Dialog";
import { withError } from "../HOC";

import styles from "./MarketingCheckbox.module.scss";

export type MarketingCheckboxProps = {
  readonly marketingLabel: string;
} & CheckboxProps;

export const MarketingCheckbox = memo<MarketingCheckboxProps>(
  ({ marketingLabel, items, ...restProps }) => {
    const [dialogVisibility, setDialogVisibility] = useState(false);

    const toggleDialogVisibility = (visibility: boolean) => (
      e: MouseEvent<HTMLElement>
    ) => {
      e.preventDefault();
      e.stopPropagation();

      setDialogVisibility(visibility);
    };

    const itemsWithMarketingLabel = items.map((item) => ({
      ...item,
      label: (
        <>
          {item.label},
          <span className={styles.label} onClick={toggleDialogVisibility(true)}>
            {marketingLabel}
          </span>
        </>
      ),
    }));

    return (
      <>
        <Dialog
          title="Klauzula informacyjna"
          isDialogVisible={dialogVisibility}
          onClose={toggleDialogVisibility(false)}
        >
          Fleet Accident Management Services Sp. Z o.o. (FAMS) działa w imieniu
          Euro Insurances DAC
          <br />
          Administratorem danych osobowych przetwarzanych w ramach procesu
          ubezpieczeniowego jest Euro Insurances DAC adres: LeasePlan House,
          Ground Floor, Central Park, Leopardstown, Dublin 18, Irlandia.
          Wszelkie zapytania do Administratora możesz składać za pośrednictwem
          Fleet Accident Management Services Sp. z o.o. w formie: pisemnej na
          adres: ul. Postępu 14 B, 02-676 Warszawa – zgodnie z obowiązującą
          ustawą o Prawie pocztowym oraz elektronicznej - wyłącznie na adres:{" "}
          <a href="mailto:privacy-officer@fams.pl">privacy-officer@fams.pl</a>.
          <br />
          Pani/Pana dane osobowe będą przetwarzane w celach:
          <br />
          <ul>
            <li>
              realizacji umowy której Pan/Pani jest stroną na podstawie art.6
              ust 1 lit b) RODO
            </li>
            <li>
              wypełnienia obowiązku prawnego ciążącego na administratorze np. w
              przypadku rozliczeń podatkowych, obsługi szkód, odpowiedzi
              reklamacyjnych lub innych czynności umocowanych w innych
              podstawach prawnych na podstawie art.6 ust 1 lit c) RODO
            </li>
            <li>
              realizacji prawnie uzasadnionego interesu realizowanego przez
              administratora w przypadku dochodzenia lub obrony przed
              roszczeniami, bieżącego kontaktu oraz przesyłania danych osobowych
              do wewnętrznych celów administracyjnych na podstawie art.6 ust.1
              lit f) RODO
            </li>
          </ul>
          <br />
          Odbiorcą Pana/Pani danych będą upoważnione podmioty na podstawie
          przepisów prawa oraz podmioty świadczące bieżące wsparcie
          Administratora danych np. usługi prawne, usługi IT.
          <br />
          Pana/Pani dane będą przetwarzany przez okres niezbędny do realizacji
          zgłoszenia/umowy oraz przez okres związany z przedawnieniem roszczeń
          wynikających na podstawie art 118 Kodeksu Cywilnego.
          <br />
          Ma Pani/Pan prawo zażądać wglądu, poprawy, aktualizacji, ograniczenia
          lub usunięcia przetwarzanych przez nas danych, sprzeciwić się ich
          przetwarzaniu lub jeśli chce Pani/Pan otrzymać elektroniczną kopię
          swoich danych osobowych w celu przekazania ich innej firmie (w
          zakresie, w jakim prawo do przenoszenia danych jest Pani/Panu
          przewidziane przez obowiązujące prawo), może się Pani/Pan z nami
          skontaktować za pośrednictwem formularza kontaktowego zamieszczonego
          na naszej stronie internetowej (
          <a href="https://www.leaseplan.com/pl">www.leaseplan.com/pl</a>).
          Przysługuje Pani/Panu prawo wniesienia skargi do Prezesa Urzędu
          Ochrony Danych Osobowych, w sposób wskazany na stronie internetowej
          ww. organu pod adresem:{" "}
          <a href="https://www.uodo.gov.pl">www.uodo.gov.pl</a>, jeśli Pani/Pan
          uzna, iż przetwarzanie Pani/Pana danych osobowych narusza przepisy
          RODO.
          <br />
          Podanie Pana/Pani danych jest niezbędne do realizacji obsługi umowy
          lub sprawy z którą się Państwo kontaktują.
          <br />
          Pana/Pani dane nie podlegają zautomatyzowanym podejmowaniu decyzji, w
          tym o profilowaniu, o którym mowa w art. 22 ust. 1 i 4 RODO.
        </Dialog>
        <Checkbox {...restProps} items={itemsWithMarketingLabel} />
      </>
    );
  }
);

export const MarketingCheckboxWithError = compose(withError)(MarketingCheckbox);
